<template>
  <el-dialog
    title="库存设置"
    :visible.sync="showDialog"
    :append-to-body="true"
    width="50%"
  >
    <el-radio-group v-model="sku_id" style="margin-bottom: 20px;" size="small">
      <el-radio-button  v-for="item in stockList.skus" :label="item.id" @change="sku_id = item.id" style="margin-bottom: 10px;">{{ item.title }}
      </el-radio-button>
    </el-radio-group>
    <el-table
      v-loading="loading"
      :border="true"
      :highlight-current-row="true"
      :data="stockList.stock_list[sku_id]"
      height="400px"
      style="width: 100%">
      <el-table-column
        prop="date"
        label="售卖日期"
      >
      </el-table-column>
      <el-table-column
        prop="stock"
        label="库存"
      >
        <el-input slot-scope="scope" v-model="scope.row.stock" size="small"
                  @blur="setSku(scope.row.date,scope.row.stock)"/>
      </el-table-column>
    </el-table>
    <div slot="footer" class="dialog-footer">
      <el-button @click="hide">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "i-fenxiao",
  props: {
    productId: {
      Type: String,
    },
    show: {
      Type: Boolean,
      default: false
    },
    value: {},
    input: {},
    loading: false
  },
  data: function () {
    return {
      sku_id: '1',
      distributionLoading: false,
      showDialog: false,
      stockList: {
        skus: [],
        stock_list: [],
      }
    }
  },
  methods: {
    hide: function () {
      this.showDialog = false;
    },
    getStockLList: function () {
      if (!this.productId) {
        return;
      }
      this.loading = true;
      this.$http.request('getSkuStockList', {pid: this.productId}).then(res => {
        this.sku_id = res.data.skus[0].id
        this.stockList = res.data;
        this.loading = false;
      });
    },
    setSku: function (date, stock) {
      this.$http.request('setSkuStock', {date: date, stock: stock, sku_id: this.sku_id}).then(res => {
        this.$notify({
          title: '成功',
          message: res.message,
          type: res.status,
          duration: 2000
        });
      });
    }
  },
  created: function () {
    this.showDialog = this.show;
    this.getStockLList();
  },
  watch: {
    show: function () {
      this.showDialog = this.show;
    },
    productId: function () {
      this.getStockLList();
    },
    showDialog: function () {
      this.$emit('change', this.showDialog);
    }
  }
}
</script>

<style scoped lang="less">
.fx-main {
  width: 100%;
  display: flex;
}

.item {
  flex-grow: 1;
  margin: 10px;
}

.item .title {
  font-size: @normal-text-font-size;
  color: @main-text-color;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/i-stock.vue